var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullscreenMode = function SvgFullscreenMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "fullscreen-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55749",
    transform: "translate(-1214.865 -1019.74)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4334",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(1214.865 1019.74)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55748"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108509",
    d: "M1239.099 1033.274v1.947h4.9l-5.052 5.076 1.355 1.355 5.076-5.052v4.9h1.947v-8.226Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108510",
    d: "m1235.424 1043.827-5.076 5.052v-4.9h-1.946v8.231h8.231v-1.947h-4.9l5.052-5.076Z",
    "data-fill": "a"
  })))));
};
export default SvgFullscreenMode;